import {useEffect, useState} from 'react';

type TuseLocalStorage = <S>(_props: {
  id: string;
  initialState?: S;
}) => [S, (_value: S | ((_prevState: S) => S)) => void];

const useLocalStorage: TuseLocalStorage = ({id, initialState}) => {
  const [value, setValue] = useState(() => {
    if (id) {
      const item = window.localStorage.getItem(id);
      return item && item !== 'undefined' ? JSON.parse(item) : initialState;
    }
    return undefined;
  });

  useEffect(() => {
    if (id) {
      window.localStorage.setItem(id, JSON.stringify(value));
    }
  }, [id, value]);

  return [value, setValue];
};

export default useLocalStorage;
